export const initialState: {
  isLoading: boolean;
  error: string;
  fullName: string;
  email: string;
  message: string;
} = {
  isLoading: false,
  error: "",
  fullName: "",
  email: "",
  message: "",
};
